import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { ActAsTypes } from "enums/actAsTypes.ts";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { getActAsTypes } from "utils/getActAsTypes.ts";
import { BaseEntityCard } from "./components/BaseEntityCard";
import { SelectTable } from "./SelectTable";

export const SelectRolePage = () => {
  const { customerId, sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const currentUser = useCurrentUser();

  const actAsTypes = getActAsTypes(currentUser.roles);

  const items = [
    ...(actAsTypes.includes(ActAsTypes.Admin)
      ? [
          {
            key: ActAsTypes.Admin,
            url: `/${customerId}/${sport}/${organizationId}/admin`,
            title: formatMessage({ id: "actAsTypes.admin" }),
          },
        ]
      : []),
    ...(actAsTypes.includes(ActAsTypes.TeamManager)
      ? [
          {
            key: ActAsTypes.TeamManager,
            url: `/${customerId}/${sport}/${organizationId}/entities`,
            title: formatMessage({ id: "actAsTypes.team-manager" }),
          },
        ]
      : []),
  ];

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle isLoading={false} title={formatMessage({ id: "selectRolePage.title" })} />
        <BackToButton to={`/${customerId}`} btnText={formatMessage({ id: "back.to.organizations" })} />
      </Row>
      <Divider />

      <Row justify="center">
        <SelectTable
          isLoading={currentUser.isLoading}
          items={items}
          render={(x: any) => <BaseEntityCard key={x.key} to={x.url} name={x.title} />}
          title={formatMessage({ id: "selectRolePage.availableRoles" })}
        />
      </Row>
    </>
  );
};
